var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 17,
    viewBox: "0 0 9 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.82096 4.03398C1.82096 4.43543 1.83598 6.39956 1.83598 6.39956H0.0527344V8.916L1.82096 8.91139L1.83598 16.8847H5.40248V8.916L7.68664 8.91139C7.68664 8.91139 7.85917 7.80629 7.96589 6.39956C7.65944 6.39956 5.40248 6.39956 5.40248 6.39956C5.40248 6.39956 5.34448 4.65696 5.34448 4.38355C5.34448 4.10943 5.72716 3.74056 6.10548 3.74056H8.01792C8.01792 3.37526 8.01792 2.11301 8.01792 0.947266C7.03272 0.947266 5.91199 0.947266 5.41768 0.947266C1.73416 0.947266 1.82096 3.6329 1.82096 4.03398Z",
    fill: "#DDDBF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.305093cf8bce308a295cf47d9fda6c9d.svg";
export { ForwardRef as ReactComponent };